/**
 * Created by shahar on 26-Nov-17.
 */

import { Injectable } from "@angular/core";
import { LogManager } from "../../log/services/log.manager";
import { LogCat } from "../../log/services/log.manager.categories";
import { ISystemConfiguration, ISystemConfigurationDetails } from "../interfaces/interfaces";
import { SystemConfigurationService } from "./system.configuration.service";

/**
 Service class for getting system configuration from server after validity checks.
*/

export type configKey = keyof ISystemConfiguration;

@Injectable({ providedIn: 'root' })
  export class SystemConfigurationValues {

	private readonly LIST_SEPERATOR = ',';

	constructor(private cfg:SystemConfigurationService ) {}

	public getNumber(key:configKey,defaultVal?:number): number {
		let stringVal = this.getValidatedString(key,""+defaultVal);
		if (isNaN(+stringVal)){
			let err="cannot parse number value for " + key +". Value is " + stringVal;
			LogManager.error(LogCat.Cfg.BadCfg,err);
			throw new Error(err);
		}else{
			return +stringVal;
		}
	}
	public getBoolean(key:configKey, defaultVal?:boolean): boolean {
		let stringVal = this.getValidatedString(key,""+defaultVal);
		switch (stringVal.toUpperCase()){
			case "T":
			case "Y":
			case "TRUE":
			case "YES":
				return true;
			case "F":
			case "N":
			case "FALSE":
			case "NO":
				return false;
			default:{
					throw new Error("cannot parse boolean value for " + key +". Value is " + stringVal);
			}
		}
	}

	public getNumberArray(key:configKey, defaultVal?:string): number[]{
		let stringVal = this.getValidatedString(key, "" + defaultVal);

		if (!stringVal) {
			return [];
		}

		return stringVal.split(this.LIST_SEPERATOR).map(strVal => +strVal);
	}

    /**
     * Get a system configuration from the lookup.
     * @param {configKey} key - the name of the key.
     * @param {string} defaultVal - optional, a value that is returned if the key does not exist.
     * @returns {string} the value of the key, if it exists, or a default value if it was provided and the key doesnt exist.
     * @throws {Error} if the value is invalid.
     */
	public getValidatedString(key:configKey,defaultVal?:string): string {
		let cfgVal:ISystemConfigurationDetails = <any> this.cfg.getCachedCfg()[key];

		if (!cfgVal && defaultVal){
			let err="invalid cfg requested <"+key+">. value is missing.";
			LogManager.warn(LogCat.Cfg.BadCfg,err);
			return defaultVal;
		}
		if (!cfgVal || cfgVal.status === "NotValid"){
			let err="invalid cfg requested <"+key+">. value is not valid.";
			LogManager.error(LogCat.Cfg.BadCfg,err);
			if (defaultVal){
				return defaultVal;
			}
			throw new Error(err);
		}
		return cfgVal.value;
	}

	public authenticatedSystemConfigurationReadyObservable(){
		return this.cfg.authenticatedSystemConfigurationReadyObservable();
	}
}
